import { NAME } from './constants';

export const SET_ACCOUNT_DATA = `${NAME}/SET_ACCOUNT_DATA`;
export const FETCH_ACCOUNT_DATA = `${NAME}/FETCH_ACCOUNT_DATA`;
export const LOGIN = `${NAME}/LOGIN`;
export const LOGOUT = `${NAME}/LOGOUT`;
export const RESET_ACCOUNT_DATA = `${NAME}/RESET_ACCOUNT_DATA`;
export const REQUEST_RESET_PASSWORD = `${NAME}/REQUEST_RESET_PASSWORD`;
export const RESET_PASSWORD = `${NAME}/RESET_PASSWORD`;
export const SET_RESET_PASSWORD_TOKEN = `${NAME}/SET_RESET_PASSWORD_TOKEN`;
export const CLEAR_RESET_PASSWORD_TOKEN = `${NAME}/CLEAR_RESET_PASSWORD_TOKEN`;
